import React, { useEffect, useState } from "react";
import "./App.css";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import TopBar from "../src/app/components/TopBar";
import BackToTop from 'react-back-to-top';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { BottomBar } from "./app/components";
import ScrollToTop from "./app/components/RouteToTop";

const theme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
      secondary: "#256ab8"
    },
    secondary: {
      main: '#256ab8'
    },
    white: {
      main: "#ffffff"
    },
    green: {
      main: "green"
    },
    red: {
      main: "red"
    },
    gray: {
      main: "gray"
    },
    blue: {
      main: "blue"
    },
    yellow: {
      main: "yellow"
    },
  }
});


function App() {

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <BrowserRouter>
          {!window.location.pathname.includes("embed") && <TopBar />}
          <div className="fullPage">
            <Router />
            <ScrollToTop />
            <BackToTop
              mainStyle={{
                "border-radius": 30,
                "background-color": "var(--secColor)"
              }}
              children={<KeyboardArrowUpIcon sx={{ color: "var(--appBg)" }} />}
              isPercent={false}
              offsetTop={0}
              step={50} />
          </div>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
